type NullableNumber = number | null | undefined;

type OrderFinancialFields = {
  fees?: NullableNumber;
  serviceFee?: NullableNumber;
  feesTjs?: NullableNumber;
  serviceFeeTjs?: NullableNumber;
  totalAmount?: NullableNumber;
  totalPrice?: NullableNumber;
  totalAmountTjs?: NullableNumber;
  totalPriceTjs?: NullableNumber;
};

const pickNumber = (...values: NullableNumber[]): NullableNumber => {
  for (const value of values) {
    if (value !== null && value !== undefined) {
      return value;
    }
  }
  return undefined;
};

export const normalizeOrderFinancialFields = <T extends OrderFinancialFields>(
  order: T,
): T => {
  if (!order || typeof order !== "object") {
    return order;
  }

  return {
    ...order,
    fees: pickNumber(order.fees, order.serviceFee),
    feesTjs: pickNumber(order.feesTjs, order.serviceFeeTjs),
    totalAmount: pickNumber(order.totalAmount, order.totalPrice),
    totalAmountTjs: pickNumber(order.totalAmountTjs, order.totalPriceTjs),
  };
};

export const normalizeOrderFinancialCollection = <
  T extends OrderFinancialFields,
>(
  orders: T[],
): T[] => orders.map((order) => normalizeOrderFinancialFields(order));
